import React, { useEffect, useRef, useState } from "react";

import sanitizeHtml from 'sanitize-html';
import { useLocation,useNavigate} from "react-router-dom";
import { useSelector } from 'react-redux';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import GameSvcMnyDpstPrdtCtntApi from "Apis/GameSvcMnyDpstPrdtCtntApi";
import PymtMthdLstApi from "Apis/PymtMthdLstApi";
import PymtMthdEvntApi from "Apis/PymtMthdEvntApi";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import DpstOdrInfotApi from "Apis/DpstOdrInfotApi";
import MembGameSvcMnyApi from "Apis/MembGameSvcMnyApi";
import "Assets/css/Shop.css";
import "Assets/css/GameMnyDpst.css";
import ImgWithFallback from "Utils/ImgWithFallback";
import { DpstOdrCrdtFunc } from "Utils/DpstOdrCrdtFunc";
import ApiResultModal from "Components/ApiResultModal";
import ShopDpstResultLayer from "Components/ShopDpstResultLayer";
import ItemOdrPchsApi from "Apis/ItemOdrPchsApi";

declare global {
    interface Window { kmcRespFunc: any; }
}

interface prdtCtntReps {
    gameSvcCd:string,
    prdtKindCd:string,
    prdtNm:string,
    prdtDesc:string,
    prdtUntPrc:string,
    pchsCrncyCd:string,
    pchsCrncySign:string,
    paidMny:string,
    freeMny:string,
    gameMnyNm:string,
    imgUrl:string,
    pchsLmtCnt:number,
    trxAllwYn:string,
    subsIntvNm:null,
    aplyStrtDtime:string,
    aplyStopDtime:string,
    allTimeYn:string,
    lmtYn?: string,
    soutYn?: string
}

interface ShopCtntMdlalUiProps {
    gameSvcCd?: string;
    shopKindCd?: string;
    prdtCd?: string;
    usePreviewDesign?: boolean;
    onRequestClose?: (getPrdtCd: string, pymtMthdCd: string, prdtPrc: string, prdtCnt: number, odrAmt: string) => void;
    onNeedChargeProduct?: (chargePrdtCd: string, sourcePrdtCd: string) => void;
    onPurchaseSuccess?: () => void;
    useParentDpstResultHandler?: boolean;
    onResultModalModeChange?: (isResultMode: boolean) => void;
}

const ShopItemMdalUi =({ gameSvcCd: propGameSvcCd, shopKindCd: propShopKindCd, prdtCd: propPrdtCd, usePreviewDesign = false, onRequestClose, onNeedChargeProduct, onPurchaseSuccess, useParentDpstResultHandler = false, onResultModalModeChange }: ShopCtntMdlalUiProps) => {
    const navigate = useNavigate();
    const location= useLocation();
    
    // 전역 store에서 로그인 정보 실시간 구독
    const loginInfoRaw = useSelector((state: any) => state.LoginInfoState?.LoginInfo);
    const loginInfo = loginInfoRaw?.apiBody;
    const storeLang = useSelector((state: any) => state.LangSetState?.Lang);
    
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = propGameSvcCd || query.get("gameSvcCd");
    let getPrdtCd = propPrdtCd || query.get("prdtCd");
    const {isLoading,error,data: langData}:any = UseLangLstQuery();

    const [ShopKindCdState,setshopKindCdState] = useState<string | null>(propShopKindCd || query.get("shopKindCd"));

    const [imgUrlState,setImgUrlState] = useState<string | undefined>(undefined);
    const [prdtNmState,setPrdtNmState] = useState<string | undefined>(undefined);
    const [prdtDescState,setPrdtDescState] = useState<string | undefined>(undefined);
    const [pchsLmtCntState,setPchsLmtCntState] = useState<number>(0);
    const [prdtUntPrcState,setPrdtUntPrcState] = useState<number>(0);
    const [paidMnyState,setPaidMnyState] = useState<number>(0);
    const [freeMnyState,setFreeMnyState] = useState<number>(0);
    const [totMnyState,setTotMnyState] = useState<string>("0");
    const [pchsCrncySignState,setPchsCrncySignState] = useState<string | undefined>(undefined);
    const [allTimeYnState,setAllTimeYnState] = useState<string | undefined>(undefined);
    const [lmtYnState, setLmtYnState] = useState<string>("N");
    const [soutYnState, setSOutYnState] = useState<string>("N");
    const [aplyStrtDtimeState,setAplyStrtDtime] = useState<string | undefined>(undefined);
    const [aplyStopDtimeState,setAplyStopDtime] = useState<string | undefined>(undefined);

    const [prdtCtntRepsState,setPrdtCtntRepsState] = useState<prdtCtntReps | null>(null);
    const [countState,setCountState] = useState(1);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const [modalStepState, setModalStepState] = useState<1 | 2>(1);
    const [pymtMthdCdState,setPymtMthdCdState] = useState("");
    const [pgCdState,setPgCdState] = useState("");
    const [pymtMthdLstState,setPymtMthdLstState] = useState<any[]>([]);
    const [showAllPymtMthdState, setShowAllPymtMthdState] = useState(false);
    const [agreChkState,setAgreChkState] = useState<string[]>([]);
    const [previewServerOpen, setPreviewServerOpen] = useState(true);
    const [previewServerState, setPreviewServerState] = useState("joannajjang(ID)-0");
    const [pymtMthdEvntState,setPymtMthdEvntState] = useState<any>(null);
    const [pymtGuideCtxtState, setPymtGuideCtxtState] = useState("");
    const [dpstResultOpenState, setDpstResultOpenState] = useState(false);
    const [dpstResultLoadingState, setDpstResultLoadingState] = useState(false);
    const [dpstResultDataState, setDpstResultDataState] = useState<any>(null);
    const [dpstOdrInfoState, setDpstOdrInfoState] = useState<any>(null);
    const [oneLmtCntState, setOneLmtCntState] = useState<number>(0);
    const handledResultRef = useRef<{ key: string; receivedAt: number }>({ key: "", receivedAt: 0 });
    const isPageReady = Boolean(langData && prdtCtntRepsState && imgUrlState && prdtNmState && !isLoading);
    const isLoginInfoResolved = loginInfoRaw !== null;
    const totalPrice = Number(prdtUntPrcState || 0) * countState;

    const payTypeEnabledMethods = [
        "CREDITCARD",
        "MOBILEPYMT",
        "RLTMACCT",
        "GIFTBOOK",
        "GIFTCLTR",
        "GIFTHPPY",
        "GIFTSMRT",
        "BKAKAOPAY",
        "BNAVERPAY",
        "BTOSSPAY"
    ];
    const shouldRenderPayType = payTypeEnabledMethods.includes(pymtMthdCdState);
    const hasMorePymtMthd = pymtMthdLstState.length > 4;
    const selectedPymtMthd = pymtMthdLstState.find(
        (item: any) => item.pymtMthdCd === pymtMthdCdState
    );
    const collapsedPymtMthdLst = selectedPymtMthd
        ? [
            selectedPymtMthd,
            ...pymtMthdLstState.filter(
                (item: any) => !(item.pymtMthdCd === selectedPymtMthd.pymtMthdCd && item.pgCd === selectedPymtMthd.pgCd)
            ),
        ].slice(0, 4)
        : pymtMthdLstState.slice(0, 4);
    const visiblePymtMthdLst = showAllPymtMthdState ? pymtMthdLstState : collapsedPymtMthdLst;
    const previewServerList = ["joannajjang(ID)", "joannajjang(ID)", "joannajjang(ID)"];

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    useEffect(() => {
        const handleDpstApiMessage = (event: Event) => {
            const customEvent = event as CustomEvent<{ code?: string; message?: string }>;
            const code = String(customEvent?.detail?.code || "");
            if (code !== "PYMT3526") {
                return;
            }

            setResultModalMessage(customEvent?.detail?.message || "결제 처리 중 오류가 발생했습니다.");
            setModalAction(null);
            setResultModalOpen(true);
        };

        window.addEventListener("dpst-api-message", handleDpstApiMessage as EventListener);
        return () => {
            window.removeEventListener("dpst-api-message", handleDpstApiMessage as EventListener);
        };
    }, []);

    const AgreTrmsFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        if (checked) {
            setAgreChkState((prev) => (prev.includes(name) ? prev : [...prev, name]));
            return;
        }
        setAgreChkState((prev) => prev.filter((choice) => choice !== name));
    };

    const PymtMthdClickFunc = (pymtMthdCd: string, pgCd: string) => {
        setPymtMthdCdState(pymtMthdCd);
        setPgCdState(pgCd);
        if (!getGameSvcCd || !getPrdtCd) {
            return;
        }
        PymtMthdEvntApi(getGameSvcCd, pymtMthdCd, getPrdtCd)
            .then((resp) => {
                setPymtMthdEvntState(resp.apiBody);
            })
            .catch(() => {
                setPymtMthdEvntState(null);
            });
    };

    const PymtBtnOnClickFunc = () => {
        if (!isPageReady) {
            openResultModal(langData?.COMM_MAIN_LOADING_00 || "로딩중입니다. 잠시 후 다시 시도해주세요.");
            return;
        }
        if (!loginInfo || !loginInfo.login) {
            const currentUrl = encodeURIComponent(location.pathname + location.search);
            openResultModal(
                langData?.COMM_ALERT_LOGIN_REQUIRED_00 || "로그인이 필요한 서비스입니다.",
                () => navigate(`/Login?referrer=${currentUrl}`)
            );
            return;
        }
        if (!pymtMthdCdState) {
            openResultModal(langData?.GAME_MNY_DPST_MTHD_TITL_00 || "결제 수단을 선택해주세요.");
            return;
        }
        if (!agreChkState.includes("agrePrivacy")) {
            openResultModal(langData?.GAME_MNY_DPST_TRMS_LBL_00 || "게임재화 이용약관 동의가 필요합니다.");
            return;
        }
        if (!getGameSvcCd || !ShopKindCdState || !getPrdtCd) {
            openResultModal(langData?.GAME_SHOP_INVALID_PRDT_INFO_00 || "결제에 필요한 상품 정보가 올바르지 않습니다.");
            return;
        }

        try {
            window.sessionStorage.setItem(
                "shopDpstReturnContext",
                JSON.stringify({
                    gameSvcCd: String(getGameSvcCd || "BBO"),
                    shopKindCd: String(ShopKindCdState || "MNY"),
                    prdtCd: String(getPrdtCd || ""),
                    pymtMthdCd: String(pymtMthdCdState || ""),
                    prdtPrc: String(prdtUntPrcState || 0),
                    prdtCnt: Number(countState || 0),
                    odrAmt: String(totalPrice || 0),
                })
            );
        } catch {
            // ignore session storage write errors
        }

        DpstOdrCrdtFunc(
            getGameSvcCd,
            pymtMthdCdState,
            ShopKindCdState,
            getPrdtCd,
            countState,
            String(totalPrice),
            String(prdtUntPrcState || 0),
            pgCdState
        );
    };

    const ItemPymtBtnOnClickFunc = () => {
        if (soutYnState === "Y") {
            openResultModal(langData?.PRDT_SOLD_OUT_BTN_00 || "품절된 상품입니다.");
            return;
        }

        if (!loginInfo || !loginInfo.login) {
            const currentUrl = encodeURIComponent(location.pathname + location.search);
            openResultModal(
                langData?.COMM_ALERT_LOGIN_REQUIRED_00 || "로그인이 필요한 서비스입니다.",
                () => navigate(`/Login?referrer=${currentUrl}`)
            );
            return;
        }

        if (!agreChkState.includes("agreInfo")) {
            openResultModal(langData?.GAME_SHOP_ITEM_PAY_AGRE_INFO_REQ_00 || "결제 전 필수 동의 항목을 확인해주세요.");
            return;
        }

        if (!getGameSvcCd || !ShopKindCdState || !getPrdtCd) {
            openResultModal(langData?.GAME_SHOP_INVALID_PRDT_INFO_00 || "결제에 필요한 상품 정보가 올바르지 않습니다.");
            return;
        }

        ItemOdrPchsApi(
            getGameSvcCd,
            ShopKindCdState,
            getPrdtCd,
            countState,
            String(prdtUntPrcState || 0),
            String(totalPrice)
        )
            .then((resp: any) => {
                const code = resp?.apiHdr?.code || "";
                if (code === "PYMT0000" || code === "COMM0000") {
                    const targetGameSvcCd = String(getGameSvcCd || "BBO");
                    const normalizedDpstCode = code === "COMM0000" ? "PYMT0000" : code;

                    onPurchaseSuccess?.();

                    setDpstResultOpenState(true);
                    setDpstResultLoadingState(false);
                    setDpstResultDataState({
                        dpstOdrNo: String(resp?.apiBody?.dpstOdrNo || ""),
                        dpstCode: normalizedDpstCode,
                        dpstMsg: String(resp?.apiHdr?.msg || langData?.GAME_SHOP_ITEM_PAY_SUCC_MSG_00 || "구매가 완료되었습니다."),
                        gameSvcCd: targetGameSvcCd,
                        closeYn: "N",
                        prdtNm: prdtNmState,
                        paidMny: String(paidMnyState || 0),
                        freeMny: String(freeMnyState || 0),
                        odrAmt: String(totalPrice),
                        pchsKindCd: "ITEM",
                    });
                    setDpstOdrInfoState({
                        dpstPrdtNm: prdtNmState,
                        odrAmt: String(totalPrice),
                        paidMny: String(paidMnyState || 0),
                        freeMny: String(freeMnyState || 0),
                    });

                    MembGameSvcMnyApi(targetGameSvcCd)
                        .then((mnyResp: any) => {
                            setTotMnyState(String(mnyResp?.apiBody?.totMny ?? "0"));
                        })
                        .catch(() => {
                            // ignore refresh errors
                        });
                    return;
                }

                if (code === "PYMT3530") {
                    const chargePrdtCd = String(resp?.apiBody?.param || "KRBBO004");
                    openResultModal(
                        resp?.apiHdr?.msg || langData?.GAME_SHOP_ITEM_NEED_CHARGE_MSG_00 || "브릭이 부족하여 충전이 필요합니다.",
                        () => {
                            if (onNeedChargeProduct) {
                                onNeedChargeProduct(chargePrdtCd, String(getPrdtCd || ""));
                            }
                        }
                    );
                    return;
                }

                if (code === "PYMT3526") {
                    setSOutYnState("Y");
                    openResultModal(resp?.apiHdr?.msg || langData?.PRDT_SOLD_OUT_BTN_00 || "품절된 상품입니다.");
                    return;
                }

                openResultModal(resp?.apiHdr?.msg || langData?.GAME_SHOP_ITEM_PAY_FAIL_MSG_00 || "결제 처리 중 오류가 발생했습니다.");
            })
            .catch((error: any) => {
                openResultModal(error?.message || langData?.GAME_SHOP_ITEM_PAY_FAIL_MSG_00 || "결제 처리 중 오류가 발생했습니다.");
            });
    };

    const CntStateChngFunc = (ArithmeticOperators:string) => {
        if (soutYnState === "Y") {
            return;
        }
        switch(ArithmeticOperators){
            case "+":
                if(pchsLmtCntState != 0) {
                    if(countState < pchsLmtCntState){
                        setCountState(countState+1);
                    }
                    else {
                        break;
                    }
                }else {
                    setCountState(countState+1);
                }
            break;
            case "-":
                if(countState <= 1){
                    break;
                }else {
                    setCountState(countState-1)
                }
            break;
        }
    }
    const GotoDpstLstFunc = () => {
        navigate(`/MyPage/GameSvcMnyDpstLst`);
    }

    const closeDpstResultUi = () => {
        setDpstResultOpenState(false);
        setDpstResultDataState(null);
        setDpstOdrInfoState(null);
        handledResultRef.current = { key: "", receivedAt: 0 };
        if (onRequestClose) {
            onRequestClose(
                String(getPrdtCd || ""),
                pymtMthdCdState,
                String(prdtUntPrcState || 0),
                countState,
                String(totalPrice)
            );
            return;
        }
        GotoDpstLstFunc();
    };

    // 팝업에서 opener.GotoDpstLstFunc() 호출 가능하도록 window에 등록
    useEffect(() => {
        (window as any).GotoDpstLstFunc = GotoDpstLstFunc;
        return () => {
            delete (window as any).GotoDpstLstFunc;
        };
    }, []);

    useEffect(() => {
        setTotMnyState(String(loginInfo?.totMny ?? "0"));
    }, [loginInfo?.totMny]);

    useEffect(() => {
        if (!loginInfo?.login || !getGameSvcCd) {
            return;
        }

        MembGameSvcMnyApi(getGameSvcCd)
            .then((resp: any) => {
                setTotMnyState(String(resp?.apiBody?.totMny ?? "0"));
            })
            .catch(() => {
                // ignore refresh errors
            });
    }, [getGameSvcCd, loginInfo?.login, storeLang]);

    useEffect(()=>{
        if(!isLoginInfoResolved || !storeLang) {
            return;
        }
        if(ShopKindCdState){
            GameSvcMnyDpstPrdtCtntApi(getGameSvcCd,ShopKindCdState,getPrdtCd).then((resp)=> {
                switch(resp.apiHdr.code) {
                    case "PYMT0000":
                        setImgUrlState(resp.apiBody.imgUrl)
                        setPrdtNmState(resp.apiBody.prdtNm)
                        setPchsLmtCntState(Number(resp.apiBody.pchsLmtCnt) || 0)
                        setPrdtUntPrcState(Number(resp.apiBody.prdtUntPrc) || 0)
                        setPchsCrncySignState(resp.apiBody.pchsCrncySign)
                        setAllTimeYnState(resp.apiBody.allTimeYn);
                        setLmtYnState(resp.apiBody.lmtYn || "N");
                        setSOutYnState(resp.apiBody.soutYn || "N");
                        setAplyStrtDtime(resp.apiBody.aplyStrtDtime);
                        setAplyStopDtime(resp.apiBody.aplyStopDtime);
                        setPaidMnyState((Number(resp.apiBody.paidMny) || 0));
                        setFreeMnyState((Number(resp.apiBody.freeMny) || 0));
                        setOneLmtCntState((resp.apiBody.oneLmtCnt || 0));
                        setPrdtCtntRepsState(resp as prdtCtntReps);
                        const dirty = resp.apiBody.prdtDesc || '';
                        const sanitized = sanitizeHtml(dirty,{});
                        setPrdtDescState(sanitized);
                    break;
                    default:
                        openResultModal(`${resp.apiHdr.msg}`,() => {
                            GotoDpstLstFunc();
                        });
                }
            }).catch(()=>{
                // ignore for now
            })
        }
    },[ShopKindCdState, getGameSvcCd, getPrdtCd, isLoginInfoResolved, storeLang])

    useEffect(() => {
        setModalStepState(1);
    }, [getPrdtCd]);

    useEffect(() => {
        setShowAllPymtMthdState(false);
    }, [getPrdtCd, ShopKindCdState]);

    useEffect(() => {
        if (onResultModalModeChange) {
            onResultModalModeChange(dpstResultOpenState);
        }
    }, [dpstResultOpenState, onResultModalModeChange]);

    useEffect(() => {
        return () => {
            if (onResultModalModeChange) {
                onResultModalModeChange(false);
            }
        };
    }, [onResultModalModeChange]);

    useEffect(() => {
        if (!getGameSvcCd || !getPrdtCd) {
            return;
        }
        PymtMthdLstApi(getGameSvcCd, getPrdtCd)
            .then((resp) => {
                setPymtMthdLstState(resp.apiBody?.pymtMthdLst || []);
            })
            .catch(() => {
                setPymtMthdLstState([]);
            });
    }, [getGameSvcCd, getPrdtCd, storeLang]);

    useEffect(() => {
        const etcGameSvcCd = String(getGameSvcCd || "BBO").toUpperCase();
        EtcCtxtApi("CTNT_KIND_ETC", "PYMT_GUIDE", etcGameSvcCd)
            .then((resp) => {
                if (resp.apiHdr.code === "COMM0000") {
                    setPymtGuideCtxtState(resp.apiBody.ctxt);
                }
            })
            .catch(() => {
                setPymtGuideCtxtState("");
            });
    }, [getGameSvcCd, storeLang]);

    useEffect(() => {
        function kmcRespFunc(kmcApiTknrslt: string, kmcApiCertNumrslt: string) {
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt, kmcApiCertNumrslt)
                .then((resp) => {
                    if (resp.apiHdr.code === "ATHN0000") {
                        if (!getGameSvcCd || !ShopKindCdState || !getPrdtCd) {
                            openResultModal(langData?.GAME_SHOP_INVALID_PRDT_INFO_00 || "결제에 필요한 상품 정보가 올바르지 않습니다.");
                            return;
                        }
                        DpstOdrCrdtFunc(
                            getGameSvcCd,
                            pymtMthdCdState,
                            ShopKindCdState,
                            getPrdtCd,
                            countState,
                            String(totalPrice),
                            String(prdtUntPrcState || 0),
                            pgCdState
                        );
                        return;
                    }
                    openResultModal(`${resp.apiHdr.msg}`);
                })
                .catch((error: any) => {
                    openResultModal(error?.message || langData?.GAME_MNY_ATHN_VRF_FAIL_00 || "본인인증 검증 중 오류가 발생했습니다.");
                });
        }

        window.kmcRespFunc = kmcRespFunc;

        return () => {
            try { window.kmcRespFunc = undefined; } catch (e) {}
        };
    }, [getGameSvcCd, getPrdtCd, ShopKindCdState, pymtMthdCdState, countState, totalPrice, prdtUntPrcState, pgCdState]);

    useEffect(() => {
        if (useParentDpstResultHandler) {
            return;
        }

        const processDpstResult = async (rawData: any) => {
            const data: any = rawData;
            if (!data || typeof data !== "object") {
                return;
            }
            if (data.type !== "navigateToResult" && data.type !== "dpstResult") {
                return;
            }

            const receivedDpstOdrNo = String(data.dpstOdrNo || "").trim();
            const receivedDpstCode = String(data.dpstCode || "").trim();
            const receivedDpstMsg = String(data.dpstMsg || "").trim();
            const receivedRcmnPrdtCd = String(data.rcmnPrdtCd || "").trim();
            const receivedPymtMthdNm = String(data.pymtMthdNm || "").trim();
            const resultKey = receivedDpstOdrNo || `${receivedDpstCode}|${receivedDpstMsg}|${receivedRcmnPrdtCd}|${receivedPymtMthdNm}`;
            const now = Date.now();
            if (!resultKey) {
                return;
            }
            if (
                handledResultRef.current.key === resultKey &&
                now - handledResultRef.current.receivedAt < 3000
            ) {
                return;
            }
            handledResultRef.current = {
                key: resultKey,
                receivedAt: now,
            };

            const targetGameSvcCd = String(data.gameSvcCd || getGameSvcCd || "BBO");
            const normalizedPchsKindCd = String(
                data.pchsKindCd || data.prdtKindCd || ShopKindCdState || "ITEM"
            ).trim().toUpperCase();
            setDpstResultOpenState(true);
            setDpstResultLoadingState(true);
            setDpstResultDataState({
                dpstOdrNo: receivedDpstOdrNo,
                dpstCode: receivedDpstCode,
                dpstMsg: receivedDpstMsg,
                gameSvcCd: targetGameSvcCd,
                closeYn: String(data.closeYn || ""),
                pchsKindCd: normalizedPchsKindCd,
            });
            setDpstOdrInfoState(null);

            try {
                if ((receivedDpstCode === "PYMT0000" || receivedDpstCode === "PYMT3502") && receivedDpstOdrNo) {
                    const [orderInfoResult, mnyResult] = await Promise.allSettled([
                        DpstOdrInfotApi(targetGameSvcCd, receivedDpstOdrNo, String(storeLang || "ko")),
                        MembGameSvcMnyApi(targetGameSvcCd),
                    ]);

                    if (orderInfoResult.status === "fulfilled") {
                        setDpstOdrInfoState(orderInfoResult.value?.apiBody || null);
                    }

                    if (mnyResult.status === "fulfilled") {
                        setTotMnyState(String(mnyResult.value?.apiBody?.totMny ?? "0"));
                    }
                }
            } finally {
                setDpstResultLoadingState(false);
            }
        };

        const handleMessage = async (event: MessageEvent) => {
            if (event?.data === "closePop") {
                return;
            }
            await processDpstResult(event?.data);
        };

        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [getGameSvcCd, storeLang, getPrdtCd, pymtMthdCdState, prdtUntPrcState, countState, totalPrice, onRequestClose, useParentDpstResultHandler]);

    if (usePreviewDesign) {
        return (
            <>
                <ApiResultModal
                    open={resultModalOpen}
                    message={resultModalMessage}
                    onClose={closeResultModal}
                    confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                />
                {dpstResultOpenState ? (
                    <div>
                        <ShopDpstResultLayer
                            loading={dpstResultLoadingState}
                            resultData={dpstResultDataState}
                            orderInfo={dpstOdrInfoState}
                            langData={langData}
                            pymtGuideCtxt={pymtGuideCtxtState}
                            totMny={totMnyState}
                            fallbackPrdtNm={prdtNmState}
                            onClose={closeDpstResultUi}
                        />
                    </div>
                ) : (
                <div className="shopCtntStepWrap shopPreviewPaymentWrap">
                    <h1 className="shopPreviewTitl">{langData?.GAME_SHOP_ITEM_PREVIEW_PAY_TITL_00 || "일반 상점 결제하기"}</h1>

                     <div className="shopPreviewPrdtWrap">
                        <div className="shopPreviewPrdtIcon">
                            <ImgWithFallback src={imgUrlState} alt={prdtNmState || (langData?.GAME_SHOP_PRDT_IMG_ALT_00 || "상품 이미지")} />
                        </div>
                        <div>
                            <h2>{prdtNmState || (langData?.GAME_SHOP_PRDT_INFO_LBL_00 || "상품 정보")}</h2>
                            <div className="shopPreviewPrdtPrice">
                                <img src={`/images/Shop/${String(pchsCrncySignState || "").toLowerCase()}Icon.png`} alt={langData?.GAME_SHOP_CURRENCY_ICON_ALT_00 || "통화 기호"} className="shopPreviewPrdtPriceIcon" />
                                <p>{`${(Number(prdtUntPrcState || 0)).toLocaleString()}`}</p>
                            </div>
                            {allTimeYnState ==="N" ? 
                            <p>{langData?.GAME_SHOP_PRDT_CNT_LBL_00 || "남은 구매 횟수"} : {pchsLmtCntState}</p>
                            :
                            <></>
                            }
                        </div>
                    </div>
                    <div className="shopPreviewPrdtDescWrap">
                        <h2>{langData && langData.GAME_SHOP_PRDT_DESC_LBL_00 || "상품 설명"}</h2>
                        <div dangerouslySetInnerHTML={{ __html: prdtDescState || "" }} style={{ whiteSpace: "pre-wrap" }} className="shopPreviewPrdtDesc" >
                        </div>
                    </div>
                    {oneLmtCntState === 1 ?
                    <></>:
                        <div className="itemTxtRow shopPayQtyRow shopPreviewQtyRow">
                            <ul>
                                <li className="prdtLbl">
                                    <p>{langData&&langData.GAME_SHOP_MNY_CNT_LBL_00}</p>
                                </li>
                                <li className="cntWrap">
                                    <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("-")}>
                                        -
                                    </button>
                                    <div>
                                        <p>{countState}</p>
                                    </div>
                                    <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("+")}>
                                        +
                                    </button>
                                </li>
                            </ul>
                        </div>
                    }

                    <div className="shopPreviewPriceWrap">
                        <div className="shopPreviewPriceRow">
                            <span>{langData?.GAME_SHOP_MY_BRICK_LBL_00 || "보유 브릭"}</span>
                            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}><img src={`/images/Shop/${String(pchsCrncySignState || "").toLowerCase()}Icon.png`} alt={langData?.GAME_SHOP_CURRENCY_ICON_ALT_00 || "통화 기호"} className="shopPreviewPrdtPriceIcon" /> {Number(totMnyState || "0").toLocaleString()}</span>
                        </div>
                        <div className="shopPreviewPriceRow total">
                            <span>{langData?.GAME_SHOP_TOT_PRC_PLAN_LBL_00 || "총 결제 예정 브릭"}</span>
                            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}><img src={`/images/Shop/${String(pchsCrncySignState || "").toLowerCase()}Icon.png`} alt={langData?.GAME_SHOP_CURRENCY_ICON_ALT_00 || "통화 기호"} className="shopPreviewPrdtPriceIcon" /> {totalPrice.toLocaleString()}</span>
                        </div>
                    </div>

                    <div className="shopPreviewChkWrap">
                        <input type="checkbox" id="agreInfo" name="agreInfo" checked={agreChkState.includes("agreInfo")} onChange={AgreTrmsFunc} />
                        <label htmlFor="agreInfo">
                            <span>{langData?.GAME_SHOP_ITEM_PAY_AGRE_INFO_LBL_00 || "결제할 상품의 정보, 수량, 결제 금액 및 유의사항을 확인하였습니다."}</span>
                        </label>
                    </div>

                    <div className="shopPreviewActionWrap">
                        <button
                            type="button"
                            className="shopPreviewSubmitBtn"
                            onClick={ItemPymtBtnOnClickFunc}
                        >
                            {langData?.GAME_SHOP_PAY_BTN_00 || "결제하기"}
                        </button>
                    </div>
                </div>
                )}
            </>
        );
    }

    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        {dpstResultOpenState ? (
            <div className="shopCtntModalContainerResult">
                <ShopDpstResultLayer
                    loading={dpstResultLoadingState}
                    resultData={dpstResultDataState}
                    orderInfo={dpstOdrInfoState}
                    langData={langData}
                    pymtGuideCtxt={pymtGuideCtxtState}
                    totMny={totMnyState}
                    fallbackPrdtNm={prdtNmState}
                    onClose={closeDpstResultUi}
                />
            </div>
        ) : (
        <div className="shopCtntStepWrap">

            {modalStepState === 1 ? (
                <div className="shopContainer shopCtntStepBody">
                    <h1 className="trmsCtgrTitl ctntCtgrTitlTxt">{langData?.GAME_SHOP_SPC_PAY_TITL_00 || "특별 상점 결제하기"}</h1>
                    <h1 className="trmsCtgrTitl ctntCtgrTitlTxt">{prdtNmState || (langData && langData.GAME_SHOP_PRDT_DESC_LBL_00)}</h1>
                    {prdtDescState != null ? (
                        <div
                            className="prdtDesc"
                            style={{ padding: "15px 0", whiteSpace: "pre-wrap" }}
                            dangerouslySetInnerHTML={{ __html: prdtDescState }}
                        />
                    ) : (
                        <div className="prdtDesc" style={{ padding: "15px 0" }}>
                            {langData?.COMM_MAIN_LOADING_00 || "로딩중입니다. 잠시 후 다시 시도해주세요."}
                        </div>
                    )}
                    <div className="shopCtntStepAction">
                        <p style={{fontSize:"20px",fontWeight:"700"}}><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)).toLocaleString()}</p>
                        <button
                            type="button"
                            className="buttonBgB"
                            disabled={!isPageReady}
                            onClick={() => setModalStepState(2)}
                        >
                            <p>{langData?.COMM_MAIN_NEXT_BTN_00 || "다음"}</p>
                        </button>
                    </div>
                </div>
            ) : (
                <div className="shopContainer dFlex shopItemInfoContainer shopCtntStepBody shopPayLayout">
                    <div className="itemImgWrap shopPayMedia">
                        <h1 className="prdtNm">{prdtNmState}</h1>
                        <div className={`itemImgFrame ${soutYnState === "Y" ? "disabled" : ""}`}>
                            <ImgWithFallback src={imgUrlState} alt="" />
                        </div>  

                        <div>
                            {prdtDescState != null ? (
                                <>
                                    <div className="prdtDescWrap">
                                        <h2>{langData && langData.GAME_SHOP_PRDT_DESC_LBL_00 || "상품 설명"}</h2>
                                    {pchsLmtCntState == 0  && allTimeYnState != "N" ?
                                        <div className="itemLmtCntWrap">
                                            <p>{langData&&langData.GAME_SHOP_PRDT_CNT_LBL_00}</p>
                                            <span>{pchsLmtCntState}</span>
                                        </div>:
                                        <></>
                                    }
                                    </div>
                                    <div className="prdtDesc" style={{padding: "15px", whiteSpace: "pre-wrap"}}
                                        dangerouslySetInnerHTML={{ __html: prdtDescState }}
                                    />
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className="itemTxtWrap shopPaySummary">
                        <div className="shopInlinePymtWrap shopPayMethods">
                            <div className="shopInlinePymtTitl">{langData && langData.GAME_MNY_DPST_MTHD_TITL_00 || "결제 수단"}</div>
                            <span className="shopInlinePymtSubTitl">
                                {langData?.GAME_MNY_DPST_MTHD_DESC_00 || langData?.GAME_MNY_DPST_MTHD_TITL_00 || "Payment Method"}
                            </span>
                            <div className={`shopInlinePymtGrid shopPayMethodGrid ${showAllPymtMthdState && hasMorePymtMthd ? "expanded" : ""}`}>
                                {visiblePymtMthdLst && visiblePymtMthdLst.map((key:any) => (
                                    <div key={`${key.pymtMthdCd}-${key.pgCd}`} className={key.dpstEvntYn == "Y" ? "shopInlinePymtItem shopPayMethodItem evntPymtMthd" : "shopInlinePymtItem shopPayMethodItem"}>
                                        <button
                                            type="button"
                                            className={`${key.dpstMntnYn == "Y" ? "disable " : (pymtMthdCdState==`${key.pymtMthdCd}` ? "active " : "")}${key.pymtMthdCd}`}
                                            disabled={key.dpstMntnYn == "Y"}
                                            onClick={() => {
                                                if (key.dpstMntnYn != "Y") {
                                                    PymtMthdClickFunc(`${key.pymtMthdCd}`,`${key.pgCd}`)
                                                }
                                            }}
                                        >
                                            {key.dpstMntnYn == "Y" ? (
                                                key.payImgUrl ? (
                                                    <img src={key.payImgUrl} alt={key.pymtMthdDesc} />
                                                ) : (
                                                    key.pymtMthdDesc
                                                )
                                            ) : (
                                                <>
                                                    <div className="pymtMthdLabel">
                                                        <input type="radio" name="pymtMthd" checked={pymtMthdCdState === `${key.pymtMthdCd}`} readOnly />
                                                        <label htmlFor={`pymtMthd-${key.pymtMthdCd}`}>
                                                            <p>{key.pymtMthdDesc}</p>
                                                        </label>
                                                    </div>
                                                    <img src={process.env.PUBLIC_URL + `/images/Shop/${key.pymtMthdCd}Img.png`} alt={key.pymtMthdDesc}/>
                                                    {key.payImgUrl ?
                                                        <img src={key.payImgUrl} alt={key.pymtMthdDesc} />
                                                        :<></>
                                                    }
                                                </>
                                            )}
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {hasMorePymtMthd && (
                                <div className="shopInlinePymtMoreWrap">
                                    <button
                                        type="button"
                                        className="shopInlinePymtMoreBtn"
                                        onClick={() => setShowAllPymtMthdState((prev) => !prev)}
                                    >
                                        {showAllPymtMthdState ? (langData?.COMM_MAIN_CLOSE_BTN_00 || "접기") : (langData?.COMM_MAIN_MORE_BTN_00 || "더보기")}
                                    </button>
                                </div>
                            )}

                            {pymtMthdEvntState && pymtMthdEvntState != null ?
                                <div className="shopInlinePymtEvent active"></div>
                                :
                                <div className="shopInlinePymtEvent"></div>
                            }

                            <div className="shopInlinePymtGuide shopPayGuide">
                                <h2>{langData && langData.GAME_MNY_DPST_DESC_TITL_00 || "결제시 유의사항 안내"}</h2>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: pymtGuideCtxtState || (langData && langData.GAME_MNY_DPST_DESC_00) || "결제 진행 시 유의사항을 꼭 확인하시기 바랍니다.",
                                    }}
                                ></p>
                            </div>

                            <div className="shopInlineTermsWrap shopPayTerms">
                                <div>
                                    <input
                                        type="checkbox"
                                        name="agrePrivacy"
                                        className="agreChkBox"
                                        id="shopAgreePrivacy"
                                        checked={agreChkState.includes("agrePrivacy")}
                                        onChange={AgreTrmsFunc}
                                    />
                                    <label htmlFor="shopAgreePrivacy">{langData && langData.GAME_MNY_DPST_TRMS_LBL_00 || "재화 이용약관 동의(필수)"}</label>
                                </div>
                            </div>

                            <form className="payment htmlFormData" method="post" name="payment">
                                <input type="hidden" name="SERVICE_ID" id="SERVICE_ID"/>
                                <input type="hidden" name="SERVICE_CODE" id="SERVICE_CODE"/>
                                <input type="hidden" name="SERVICE_TYPE" id="SERVICE_TYPE"/>
                                <input type="hidden" name="ITEM_NAME" id="ITEM_NAME"/>
                                <input type="hidden" name="ORDER_ID" id="ORDER_ID"/>
                                <input type="hidden" name="ORDER_DATE" id="ORDER_DATE"/>
                                <input type="hidden" name="AMOUNT" id="AMOUNT"/>
                                <input type="hidden" name="RETURN_URL" id="RETURN_URL"/>
                                <input type="hidden" name="ITEM_CODE" id="ITEM_CODE"/>
                                <input type="hidden" name="USER_ID" id="USER_ID"/>
                                <input type="hidden" name="USER_NAME" id="USER_NAME"/>
                                <input type="hidden" name="USER_EMAIL" id="USER_EMAIL"/>
                                <input type="hidden" name="RESERVED1" id="RESERVED1"/>
                                <input type="hidden" name="RESERVED2" id="RESERVED2"/>
                                <input type="hidden" name="RESERVED3" id="RESERVED3"/>
                                <input type="hidden" name="CANCEL_FLAG" id="CANCEL_FLAG"/>
                                <input type="hidden" name="WEBAPI_FLAG" id="WEBAPI_FLAG"/>
                                {shouldRenderPayType && (
                                <input type="hidden" name="PAY_TYPE" id="PAY_TYPE"/>
                                )}
                                <input type="hidden" name="HASH_KEY" id="HASH_KEY"/>
                                <input type="hidden" name="LOGO" id="LOGO"/>
                                <input type="hidden" name="INSTALLMENT_PERIOD" id="INSTALLMENT_PERIOD"/>
                            </form>
                        </div>
                        {oneLmtCntState === 1 ? 
                            <></> :
                            <div className="itemTxtRow shopPayQtyRow">
                                <ul>
                                    <li className="prdtLbl">
                                        <p>{langData&&langData.GAME_SHOP_MNY_CNT_LBL_00}</p>
                                    </li>
                                    <li className="cntWrap">
                                        <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("-")}>
                                            -
                                        </button>
                                        <div>
                                            <p>{countState}</p>
                                        </div>
                                        <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("+")}>
                                            +
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }
                        <div className="itemTxtRow02 shopPayPriceRow">
                            <ul>
                                <li className="prdtLbl">
                                    <p>{langData&&langData.GAME_SHOP_MNY_PRC_LBL_00}</p>
                                </li>
                                <li className="prdtLbl">
                                    <p><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)).toLocaleString()}</p>
                                </li>
                            </ul>
                        </div>
                        <div className="itemTxtRow02 itemTxtRowTotal shopPayTotalRow">
                            <ul>
                                <li className="prdtLbl">
                                    <p>{langData&&langData.GAME_SHOP_TOT_PRC_LBL_00}</p>
                                </li>
                                <li className="prdtLbl">
                                    <p><span>{pchsCrncySignState}{(Number(prdtUntPrcState||0)*countState).toLocaleString()}</span></p>
                                </li>
                            </ul>
                        </div>
                        <div className="shopCtntStepAction btn100 shopPaySubmit">
                            <button
                                className={`buttonBgB ${soutYnState === "Y" || !isPageReady ? "disabled" : ""}`}
                                disabled={soutYnState === "Y" || !isPageReady}
                                onClick={PymtBtnOnClickFunc}>
                                <p>{soutYnState === "Y" ? (langData&&langData.PRDT_SOLD_OUT_BTN_00) : (langData&&langData.GAME_SHOP_MNY_DPST_BTN_00)}</p>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        )}
        </>
    )
}



export default ShopItemMdalUi;
